import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FiltroDocs } from 'src/app/shared/models/filtros';
import { IRecuperarTiposDocumentoService } from 'src/app/pages/configuracion/Envios/documentos/services/ports/i-recuperar-tipos-documento-service';
import { EstadosTipoDocumento, EstadosTipoDocumentoApi, GenericoTipoDocumento, TipoDocumento } from '../models/tipo-documento';
import { iDocumentoPdfConfiguracionService } from './ports/i-documento-pdf-configuracion-service';
import { FirmanteNif } from '../models/firmante-nif';
import { DesplegableData } from 'src/app/shared/components/sqp-components/sqpDesplegable/models/desplegable-data';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { FiltroSqp } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';

@Injectable({
  providedIn: 'root'
})
export class DatosDocumentosService {

  public documentos: TipoDocumento[]; // = [];
  docsFiltrados: TipoDocumento[]; // = [];
  filtros: FiltroDocs[] = [];
  columnDef: ColDef[] = [];
  negrita: boolean = false;
  configDoc: boolean = false;
  refreshDocs: boolean;
  documentosAll: TipoDocumento[];

  constructor(@Inject('RecuperaTipoDocumento')
        private datosDocumento: IRecuperarTiposDocumentoService,
              @Inject('DocumentoPdfConfiguracion') private documentoPdfConfiguracion: iDocumentoPdfConfiguracionService) {
              }

  getTipoDocumentos(filtrosSqp: FiltroSqp[], pageNumber:number, pageSize:number = 500, orden?: OrdenColumna): Observable<TipoDocumento[]>{

    return this.datosDocumento.getTipoDocumentos(filtrosSqp, pageNumber, pageSize, orden)
      .pipe(
        map(resp => {

            this.documentos = resp;
            this.documentos.forEach(x=>{
              x.estado = this.mostrarEstadoGrid(x.estado);
              x.tipoDoc = this.mostrarGenericoGrid(x.generico)
            }
            )
            this.refreshDocs = false;
            return this.documentos;
          }
        )
    );
  }

  mostrarEstadoGrid(estadoDocumento: string): string{
    let estadoDocumentoGrid: string = '';
    switch (estadoDocumento){
      case EstadosTipoDocumentoApi.completo:
        estadoDocumentoGrid = EstadosTipoDocumento.completo
        break;
      case EstadosTipoDocumentoApi.incompleto:
        estadoDocumentoGrid = EstadosTipoDocumento.incompleto
        break;
    }
    return estadoDocumentoGrid;
    }

  mostrarGenericoGrid(genericoDocumento: boolean): string{
    let genericoDocumentoGrid: string = '';
    switch(genericoDocumento){
      case false:
        genericoDocumentoGrid = GenericoTipoDocumento.docDatosPers
        break;
      case true:
        genericoDocumentoGrid = GenericoTipoDocumento.plantilla
    }
    return genericoDocumentoGrid;
  }

  getTipoDocumento(id: number): Observable<TipoDocumento | null> {
    return this.getTipoDocumentosAll([], 0, 0).pipe(
      map(() => {
        const found = this.documentosAll?.find(x => x.idTipoDocumento === id);
        return found ?? null;
      })
    );
  }

  SetFilter(_filtros: FiltroDocs[]){
    this.filtros = _filtros;
  }

  // Aplicamos los filtros cargados al listado completo de documentos y guardamos el resultado
  Filter(){
    this.docsFiltrados = [];
    this.docsFiltrados = this.documentos;
    if(this.filtros.length == 0){
      this.docsFiltrados = this.documentos;
    }else{
      for( const filter of this.filtros){
        if(filter.textoBuscar.trim() != ""){
          this.docsFiltrados =  this.docsFiltrados.filter(x =>
            x.tipoDoc.toString().toUpperCase().includes(filter.textoBuscar.toLocaleUpperCase()) ||
            x.nombre.toString().toUpperCase().includes(filter.textoBuscar.toUpperCase()) ||
            x.paginas.toString().toUpperCase().includes(filter.textoBuscar.toUpperCase()) ||
            this.filterFirmantesNif(x.firmantesNif, filter)
          )
        }
        if(filter.tipoDoc?.trim() !="" && filter.tipoDoc?.trim().toUpperCase() != "TODOS"){
          this.docsFiltrados = this.docsFiltrados.filter(x => x.tipoDoc == filter.tipoDoc);
        }
        if(filter.nombre?.trim() !="" && filter.nombre?.trim().toUpperCase() != "TODOS"){
          this.docsFiltrados = this.docsFiltrados.filter(x => x.nombre == filter.nombre);
        }
      }
      this.docsFiltrados?.forEach(x => {
        if(! this.docsFiltrados.includes(x))  this.docsFiltrados.push(x);
      })
    }
  }

  filterFirmantesNif(firmantesNif: FirmanteNif[] | number, filter: FiltroDocs):boolean{
    if(Array.isArray(firmantesNif)){
      if(firmantesNif?.length.toString().toUpperCase().includes(filter.textoBuscar.toUpperCase())) return true;
      else return false
    }else{
      if(firmantesNif?.toString().toUpperCase().includes(filter.textoBuscar.toUpperCase())) return true;
      else return false
    }
  }

  // Obtenemos el listado de estados de los documentos
  GetEstadosLista(): DesplegableData[]{
    let estados: DesplegableData[] = [];
    estados.push({id:'TODOS',desc:'Estado'});
    estados.push({
                    id: EstadosTipoDocumento.incompleto,
                    desc: EstadosTipoDocumento.incompleto
                  },
                  {
                    id: EstadosTipoDocumento.completo,
                    desc: EstadosTipoDocumento.completo
                  }
                )
    return estados;
  }

  // Obtenemos el listado de tipos de documento
  GetTipoDocumentosLista(): DesplegableData[]{
    let tipoDocumentos: DesplegableData[] = [];
    tipoDocumentos.push({id:'TODOS',desc:'Todos los tipos documento'});
    tipoDocumentos.push({
      id: GenericoTipoDocumento.plantilla,
      desc: GenericoTipoDocumento.plantilla
    },
    {
      id: GenericoTipoDocumento.docDatosPers,
      desc: GenericoTipoDocumento.docDatosPers
    })
    return tipoDocumentos;
  }

  GetNombreDocsLista(): DesplegableData[]{
    let nombre: DesplegableData[] = [];
    nombre.push({id:'TODOS',desc:'Nombre documento'});
    this.documentos.forEach(x => {
      if(!nombre.find(y => y.id == x.idTipoDocumento.toString())){
        nombre.push({id: x.idTipoDocumento.toString(), desc: x.nombre})
      }
    })
    return nombre;
  }

  // Configuración documento PDF

  putDocumentoTemporal(file:FileList): Observable<string> {
    return this.documentoPdfConfiguracion.putDocumentoTemporal(file)
      .pipe(
        map(respuesta => {
            return respuesta;
          }
        )
    )
  }

  getDocumentoTemporal(id: string): Observable<string> {
    return this.documentoPdfConfiguracion.getDocumentoTemporal(id)
      .pipe(
        map(respuesta => {
          return respuesta;
        })
      )
  }

  traeCif(id: string, pagina: number, orden: number): Observable<string>{
    return this.documentoPdfConfiguracion.traeCif(id, pagina, orden)
    .pipe(
      map(respuesta => {
        return respuesta;
      })
    )
  }

  traeNif(id: string, pagina: number, orden: number): Observable<string>{
    return this.documentoPdfConfiguracion.traeNif(id, pagina, orden)
    .pipe(
      map(respuesta => {
        return respuesta;
      })
    )
  }

  guardaDocumento(objetoDocumento: TipoDocumento): Observable<any>{
    return this.datosDocumento.guardaDocumento(objetoDocumento);
  }

  filtraInterno(filtro: FiltroDocs, arrayDocumentos: TipoDocumento[]){
    let listaFiltrada: TipoDocumento[] = [];
    if(this.filtros.length == 0){
      listaFiltrada = arrayDocumentos;
    }else{
      for( const filter of this.filtros){
        if(filter.textoBuscar.trim() != ""){
          listaFiltrada =  arrayDocumentos.filter(x =>
            x.tipoDoc.toString().toUpperCase().includes(filter.textoBuscar.toLocaleUpperCase()) ||
            x.nombre.toString().toUpperCase().includes(filter.textoBuscar.toUpperCase()) ||
            x.paginas.toString().toUpperCase().includes(filter.textoBuscar.toUpperCase()) ||
            this.filterFirmantesNif(x.firmantesNif, filter)
          )
        }
        if(filter.tipoDoc?.trim() !="" && filter.tipoDoc?.trim().toUpperCase() != "TODOS"){
          this.docsFiltrados = this.docsFiltrados.filter(x => x.tipoDoc == filter.tipoDoc);
        }
        if(filter.nombre?.trim() !="" && filter.nombre?.trim().toUpperCase() != "TODOS"){
          this.docsFiltrados = this.docsFiltrados.filter(x => x.nombre == filter.nombre);
        }
      }
      this.docsFiltrados?.forEach(x => {
        if(! this.docsFiltrados.includes(x))  this.docsFiltrados.push(x);
      })
    }
  }

  getTipoDocumentosAll(filtrosSqp: FiltroSqp[], pageNumber:number, pageSize:number = 500, orden?: OrdenColumna): Observable<TipoDocumento[]>{
    return this.datosDocumento.getTipoDocumentos([],0,0)
      .pipe(
        map(resp => {
            this.documentosAll = resp;
            this.documentosAll.forEach(x=>{
              x.estado = this.mostrarEstadoGrid(x.estado);
              x.tipoDoc = this.mostrarGenericoGrid(x.generico)
            }
            )
            return this.documentosAll;
          }
        )
    );
  }
}
